import { Anchor, Avatar, Button, Divider, Group, Modal, Text } from "@mantine/core";
import { get } from "http";
import { useEffect, useState } from "react";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import modulecss from "./MandateDetailsModal.module.css";

// Icons: 
import subIcon from "../../../assets/img/subscription.png";
import bankIcon from "../../../assets/img/bank.png";
import { MandateData } from "../../../types/types";
import { IconBuildingBank, IconCircleCheckFilled, IconCoins, IconRotate, IconUser } from "@tabler/icons-react";


interface MandateDetailsModal {
    opened: boolean;
    close(): void;
    mandateID: string;
}

export function MandateDetailsModal(props: MandateDetailsModal) {
    const [loading, setLoading] = useState<boolean>();
    const [data, setData] = useState<MandateData>();

    // Fetch mandate details
    useEffect(() => {
        setLoading(true);
        async function getMandateDetails(mandateID: string) {
            const response = await fetch(window.location.origin + "/server/client_service/mandates/" + mandateID);
            const data = await response.json();
            setData(data);
            console.log("Mandate details: ", data);
            setLoading(false);
            // TODO: Set this to a hook so we can display it in the modal.

        }
        if (props.opened) {
            getMandateDetails(props.mandateID);
        }

    }, [props.opened]);

    return (

        <Modal
            opened={props.opened}
            onClose={props.close}
            size="xl"
            title="Mandate Details"
            centered
            overlayProps={{
                backgroundOpacity: 0.55,
                blur: 3,
            }}
        >
            {!loading ? (
                <>
                    <Group justify="space-around" wrap="nowrap" p={15} pb={50}>
                        <Group wrap="nowrap">
                            <Anchor href="https://www.flaticon.com/free-icons/subscription" target="_blank" rel="noopener noreferrer">
                                <Avatar src={subIcon} size={94} radius="md" />
                            </Anchor>

                            <div>
                                <Text fz="xs" tt="uppercase" fw={700} c="dimmed">
                                    ***Associated Subscription
                                </Text>

                                <Text fz="lg" fw={500} className={modulecss.name}>
                                    ***Subscription name
                                </Text>

                                <Group wrap="nowrap" gap={10} mt={3}>

                                    <IconCircleCheckFilled
                                        stroke={1.5}
                                        size={16}
                                        className={modulecss.icon}
                                    />


                                    <Text fz="xs" c="dimmed">
                                        ***Subscription Status
                                    </Text>
                                </Group>

                                <Group wrap="nowrap" gap={10} mt={5}>
                                    <IconCoins stroke={1.5} size={16} className={modulecss.icon} />
                                    <Text fz="xs" c="dimmed">
                                        R{data?.recurring_amount}
                                    </Text>
                                </Group>

                                <Group wrap="nowrap" gap={10} mt={5}>
                                    <IconRotate stroke={1.5} size={16} className={modulecss.icon} />
                                    <Text fz="xs" c="dimmed">
                                        {data?.frequency}
                                    </Text>
                                </Group>

                            </div>
                        </Group>

                        <Group wrap="nowrap">
                            <Anchor href="https://www.flaticon.com/free-icons/bank" target="_blank" rel="noopener noreferrer">
                                <Avatar src={bankIcon} size={94} radius="md" />
                            </Anchor>
                            <div>
                                <Text fz="xs" tt="uppercase" fw={700} c="dimmed">
                                    Bank Account
                                </Text>

                                <Text fz="lg" fw={500} className={modulecss.name}>
                                    {data?.mandate.bank_account_number}
                                </Text>

                                <Group wrap="nowrap" gap={10} mt={3}>
                                    <IconBuildingBank
                                        stroke={1.5}
                                        size={16}
                                        className={modulecss.icon}
                                    />
                                    <Text fz="xs" c="dimmed">
                                        {data?.mandate.bank_name}
                                    </Text>
                                </Group>

                                <Group wrap="nowrap" gap={10} mt={3}>
                                    <IconUser
                                        stroke={1.5}
                                        size={16}
                                        className={modulecss.icon}
                                    />
                                    <Text fz="xs" c="dimmed">
                                        {data?.mandate.bank_account_holder_name}
                                    </Text>

                                </Group>

                                <Group wrap="nowrap" gap={10} mt={3}>
                                    <IconCircleCheckFilled
                                        stroke={1.5}
                                        size={16}
                                        className={modulecss.icon}
                                    />
                                    <Text fz="xs" c="dimmed">
                                        {data?.type}
                                    </Text>

                                </Group>

                            </div>
                        </Group>
                    </Group>
                    <Divider my="sm" />
                    <Group justify="center" mt="md">
                        <Button radius="xl" size="sm" variant="outline" style={{ borderColor: "#00ddb3", color: "#00ddb3" }}>
                            Request cancellation
                        </Button>
                    </Group>

                </>
            ) : (
                <LoadingSpinner size="md" color="blue" h="10vh" />
            )
            }
        </Modal>
    )
}

